<div
  class="element-wrapper"
  [class.no-indicator-delay]="isLoaderVisible()"
  [ngStyle]="wrapperStyles"
>
  <button [class.is-disabled]="isDisabled()" [ngStyle]="buttonStyles" (click)="emitClick()">
    <div class="shade"></div>
    @let isPending = isPending$ | async;
    @if (isLoaderVisible() || (showLoader && isPending)) {
      <blaze-element-loading-indicator mode="white" [isVisible]="true" />
    }
    @if (icon) {
      <mat-icon [svgIcon]="icon" [style.--icon-size]="props?.style?.label?.iconSize" />
    }
    @if (label) {
      <span class="-my-8">{{ label }}</span>
    }
  </button>
</div>
